import { atom } from "jotai";

export const solicitudesAusenciaPendientesAtom = atom(false);
export const solicitudAusenciaSeleccionadaAtom = atom(undefined);
export const visibleModalAprobarSolicitudAtom = atom(false);
export const visibleModalRechazarSolicitudAtom = atom(false);
export const visibleModalAdjuntosAtom = atom (false);
export const formulariosAtom =atom([]);
